import $$ from 'cmn-utils'


const baseUrl = "/api/datav/common/";
export default {
    totalBase: (params) => {
        return $$.get(baseUrl + 'total-base', params)
    },
}